/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { AnnouncementFromJSON, AnnouncementToJSON } from './Announcement';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetAnnouncementsResponseDataFromJSON(json) {
    return GetAnnouncementsResponseDataFromJSONTyped(json, false);
}
export function GetAnnouncementsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        announcements: !exists(json, 'announcements')
            ? undefined
            : json['announcements'].map(AnnouncementFromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info']),
        unreadCount: !exists(json, 'unread_count') ? undefined : json['unread_count']
    };
}
export function GetAnnouncementsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        announcements: value.announcements === undefined ? undefined : value.announcements.map(AnnouncementToJSON),
        page_info: PageInfoToJSON(value.pageInfo),
        unread_count: value.unreadCount
    };
}
